module.exports = __webpack_public_path__ + "img/banner.16b60296.png";